import { useRouter } from 'next/router';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import {
  CategoryHeader,
  CategoryItem,
  CategoryThumbnail,
  CategoryContent,
  CategoryTitle,
  CategoryDescription,
  CategoryChevron,
  CategoryList,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

// Category descriptions mapping
// const categoryDescriptions = {
//   'Skin Care': 'Find your skin BFFs that have solution to your every skin concern',
//   'Hair Care': 'Science-backed & effective range of products are rooting for your Hair Health',
//   'Preg & Moms': 'Safe & effective solutions to make pregnancy & motherhood the best phase of your life!',
//   'Baby Care': "Making baby grooming fun with gentle, effective products for your little one's skin, hair, & body",
//   'Diapers': 'Free your baby\'s bums from any discomfort with our safest and rash-free diapering',
//   'More': 'Find your skin BFFs that have solution to your every skin concern',
// };

export default function NewCategory(props) {
  const { categoryData, setDrawerOpen } = props;
  const router = useRouter();

  const categoryClickHandler = (category, indexData) => {
    if (!category?.key) return;
    
    document.documentElement.classList.add('normal-scroll');
    fireEvent({
      category: 'clicked_sidedrawer_item',
      screen_name: 'STORE_HOME',
      parent: category?.tabName,
      item_name: category?.tabName,
    });
    
    let params = new URLSearchParams(window.location.search);
    params.delete('subcategory');
    params = Array.from(params)?.length > 0 ? '?' + params : '';
    
    router.push(category?.key + params, '', {
      locale: getRouterLocale(router),
    });
    
    setTimeout(() => setDrawerOpen(false), 500);
  };

  // Check if category is active based on current route
  const isCategoryActive = (category) => {
    if (!category?.key) return false;
    const currentPath = router.asPath.split('?')[0];
    return currentPath === category.key ;
  };

  return (
    <>
      <CategoryHeader>ALL CATEGORIES</CategoryHeader>
      <CategoryList>
        {categoryData?.map((category, index) => {
          const categoryName = category?.tabName || '';
          const description =  category?.tabDescription || '';
          const thumbnail =  category?.tabIcon || '';
         
          const isLastItem = index === categoryData.length - 1;

          return (
            <CategoryItem
              key={`categoryItem${index}`}
              onClick={() => categoryClickHandler(category, index)}
              
            >
              {thumbnail && (
                <CategoryThumbnail>
                  <img src={thumbnail} alt={categoryName} />
                </CategoryThumbnail>
              )}
              <CategoryContent>
                <CategoryTitle>{categoryName}</CategoryTitle>
                {description && (
                  <CategoryDescription>{description}</CategoryDescription>
                )}
              </CategoryContent>
              <CategoryChevron>
                <img 
    src="https://images.myloapp.in/NestJsUploads/1762494123775-Vector_arrow.svg" 
    alt="arrow"
    width="16"
    height="16"
  />
                
                
                
              </CategoryChevron>
            </CategoryItem>
          );
        })}
      </CategoryList>
    </>
  );
}
